import type {CSSProperties} from 'react';
import {radius, weight} from '../scale.js';
import {wedgeExactRole} from './wedgeRoles.js';

export type WedgeAccountContactsLook = 'contacts-ghost' | 'contacts-primary' | 'contacts-primary-dark';

const CONTACTS_LOOKS = new Set<string>(['contacts-ghost', 'contacts-primary', 'contacts-primary-dark']);
export const isWedgeAccountContactsLook = (look: string): look is WedgeAccountContactsLook => CONTACTS_LOOKS.has(look);

/* Released tap buttons of the rep contact form in the account card (prep-account-contacts rvTapBtn), off-scale. Each is a 44px box
   with a 10px radius, no border, 14px bold type in the body face. The ghost look (the idle kind buttons and Cancel) is clear of the
   canvas on the elevated fill in the primary ink. The primary look (the chosen kind button and Save) fills with the dark accent in
   the light theme and the accent in the dark theme (the small-ink rule of the card), with the on-accent ink. The two primary looks
   exist because the fill follows the theme the caller already knows, not a variable. The caller sets the flex share of a kind button
   and the held state of Save (opacity and cursor). The box is 44px tall already, so no look here draws a transparent target
   (wedgeAccountContactsDrawsHit). */
export const wedgeAccountContactsDrawsHit = (look: string): boolean => !isWedgeAccountContactsLook(look);

export function wedgeAccountContactsStyle(look: WedgeAccountContactsLook): CSSProperties {
  const r = wedgeExactRole;
  const primary = look !== 'contacts-ghost';
  return {
    minHeight: 44, minWidth: 44, padding: '0 14px', borderRadius: radius.md, border: 'none', cursor: 'pointer',
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6, fontFamily: r('font'), fontSize: 14, fontWeight: weight.bold,
    background: primary ? r(look === 'contacts-primary-dark' ? 'accent' : 'accentDark') : r('bgElev'), color: primary ? r('onAccent') : r('label'),
  };
}
